// Vite equivalent of webpack `require.context` — eager-glob all locale JSON files
// at build time, flatten into a single id→message map per language.
const enModules = import.meta.glob('./en/**/*.json', { eager: true });
const frModules = import.meta.glob('./fr/**/*.json', { eager: true });

const flatten = (modules) => {
    const translations = {};
    for (const key in modules) {
        const mod = modules[key];
        Object.assign(translations, mod.default || mod);
    }
    return translations;
};

export const enMessages = flatten(enModules);
export const frMessages = flatten(frModules);

export default {
    en: enMessages,
    fr: frMessages,
};
